import { Grid } from '@mui/material';
import OrbitFeeTrackerAbi from 'pages/avs/contracts/OrbitFeeTrackerAbi';
import { trexTestnet } from 'pages/raas/constants/chains';
import { MetricWidget } from 'shared/components/metric/MetricWidget';
import { formatWeiToEth } from 'shared/utils/strings';
import { useReadContract } from 'wagmi';

const ORBIT_STATS_CONTRACT_ADDRESS = '0x000000000000000000000000000000000000006C';

const OrbitGasStatsMetric: React.FC = () => {
  const orbitBaseFee = useReadContract({
    address: ORBIT_STATS_CONTRACT_ADDRESS,
    abi: OrbitFeeTrackerAbi,
    functionName: 'getMinimumGasPrice',
    chainId: trexTestnet.id,
  });

  const parentBaseFee = useReadContract({
    address: ORBIT_STATS_CONTRACT_ADDRESS,
    abi: OrbitFeeTrackerAbi,
    functionName: 'getL1BaseFeeEstimate',
    chainId: trexTestnet.id,
  });

  const parentPricingSurplus = useReadContract({
    address: ORBIT_STATS_CONTRACT_ADDRESS,
    abi: OrbitFeeTrackerAbi,
    functionName: 'getL1PricingSurplus',
    chainId: trexTestnet.id,
  });

  const feeMetrics = [
    { title: 'Orbit Base Fee', value: formatWeiToEth(orbitBaseFee?.data ?? 0n) },
    { title: 'Parent Base Fee', value: formatWeiToEth(parentBaseFee?.data ?? 0n) },
    {
      title: 'Parent Pricing Surplus',
      value: formatWeiToEth(parentPricingSurplus?.data ?? 0n),
    },
  ];

  return (
    <Grid container>
      {feeMetrics.map(metric => (
        <MetricWidget key={metric.title} label={metric.title} value={`${metric.value} ETH`} />
      ))}
    </Grid>
  );
};

export default OrbitGasStatsMetric;
